import styled from 'styled-components';
import { options } from 'toastr';

export const Container = styled.div`

    .dashboard-body{
        margin-top: 32px;
        .dashboard-body-filters{
            margin-bottom: 28px;
            div{
                select{
                    border-radius: 2px;
                    cursor: pointer;
                    padding: 0 6px ;
                    border: 2px solid #d5d5e0;
                    color: #000000;
                    height: 30px;
                    width: 100%;
                    font-weight: bold;
                    box-shadow: 0px 3px 20px #0000000D;
                    option{
                        background-color: #F6F8FA;
                        color: #000000;
                        cursor: pointer;
                    }
                    &:focus-visible{
                        outline: none;
                    }
                }
            }
        }
    }

    .dashboard-title{
        display: flex;
        margin-top: 4rem;
        justify-content: space-between;
        align-items: center;
        h3{
            color: #112A61;
            font-weight: bolder;
            padding-left: 1rem;
        }
    }

    .form-rules{
        padding: 10px;
        margin-top: 18px;
        display: block;
        border-radius: 6px;
    }

    .form-existent{
        padding: 10px;
        margin-top: 18px;
        display: block;
        border-radius: 6px;
    }

    .text {
        color: #102a63;
    }

    tr:first-child td:first-child { border-top-left-radius: 8px; }
    tr:first-child td:last-child { border-top-right-radius: 8px; }

    tr:last-child td:first-child { border-bottom-left-radius: 8px; }
    tr:last-child td:last-child { border-bottom-right-radius: 8px; }

    tr:first-child td:first-child { border-bottom-left-radius: 8px; }
    tr:first-child td:last-child { border-bottom-right-radius: 8px; }

    tr:last-child td:first-child { border-top-left-radius: 8px; }
    tr:last-child td:last-child { border-top-right-radius: 8px; }

    .form {
        transform:translate(8%,-24%);
        padding-left: 10px;
    }

    .value {
        transform:translate(2%,-24%);
        padding-left: 0rem;
        display: flex;
    }

    .checkbox {
        width: 17px;
        height: 17px;
        background-color: #fff;
        border: 1px solid #c5c5c5;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 2px;

        margin-right: 10px;
        cursor: pointer;
    }
        input[type="checkbox"] {
        appearance: none;
    }

    input[type="checkbox"]:checked::before {
    content: "V";
    color: #9da09d;
    font-weight: bolder;
    }

    .discussion{
        margin-top: 15px;
        h5{
            color: #000000;
            font-weight: bolder;
            font-size: 15px;
        }
        textarea{
            border: 1px solid #cfcfcf;
            border-radius: 4px;
        }
    }

    textarea:focus{
    box-shadow: 0 0 0 0;
    border: 1px solid #cfcfcf;
    outline: 0;
}


    .options{
        background: #fff;
        margin-bottom: 10px;
        tr{
            td{
                padding: 7px 15px;
            }
        }
    }

    .form-title{
        width: 100%;
        span{
            font-weight: bold;
            color: #102A63;
            padding-right: 3rem;
        }
    }

    .form-title p{
        font-size: small;
        color: #102a63;
        padding-top: 3px;
        margin-bottom: 0px;
    }

    .icon{
        margin: 8px 20px -8px 5px;
    }

    .blue-dark{
        background: #102a63;
        color: #fff;
        border: none;
        border-radius: 8px;
        height: 35px;
        width: 160px;
        padding: 5px;
        font-weight: bolder;
    }

    .gray{
        background: #b0b0bb;
        color: #fff;
        border: none;
        border-radius: 8px;
        height: 35px;
        width: 160px;
        padding: 5px;
        font-weight: bolder;
    }

    .buttons {
    display: flex;
    }

    .buttons-container{
        margin-right: 10px;
    }

    .buttons button {
    margin-left: 15px;
    }

    .no-event{
        color: #102a63;
        font-weight: bolder;
        display: flex;
        justify-content: center;
        height: 70px;
        width: 100%;
        align-items: center;
        display: flex;
        border-radius: 6px;
    }
`;

export const CustomCard = styled.div`
  background-color: #ffffff; /* Set your background color */
  border: 1px solid #eaeaea; /* Set your border style */
  border-radius: 8px; /* Set your border radius */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Set your box shadow */

  .header {
    background-color: #ffffff; /* Set header background color */
    padding: 16px; /* Set header padding */
  }

  h2 {
    margin: 0; /* Reset margin for h1 inside the header */
    color: #333333; /* Set header text color */
  }

  .body {
    padding: 16px; /* Set body padding */
  }

  p {
    margin: 0; /* Reset margin for p inside the body */
    color: #666666; /* Set body text color */
  }

  .filters-section{
    margin-left: 5px;
    margin-bottom: 1rem;
  }

  select{
        border-radius: 4px;
        cursor: pointer;
        margin: 16px;
        border: 1px solid #ECECF3;
        color: #7F7F8A;
        height: 30px;
        width: 100%;

        option{
            background-color: #F6F8FA;
            color: black;
            cursor: pointer;
        }

        &:focus-visible{
            outline: none;
        }
    }
`;

export const FormSAR = styled.div`
padding: 2rem;
.arp-container { max-width: 1080px; margin: 0 auto; padding: 16px; }
.arp-title { font-size: 20px; font-weight: 600; margin: 0 0 2px; }
.arp-sub { color: #6b7280; font-size: 12px; margin-bottom: 12px; }

/* Toolbar */
.toolbar { display: flex; gap: 12px; justify-content: space-between; align-items: end; flex-wrap: wrap; margin: 12px 0 16px; }
.toolbar .field { display: flex; flex-direction: column; gap: 4px; font-size: 12px; width:12rem; }
select, input[type="number"], textarea { border: 1px solid #cccccc; border-radius: 4px; padding: 10px; font-size: 11px; background: #fff; width: 100%; }
textarea { resize: vertical; }

/* Disabled inputs styling */
input[type="number"]:disabled, 
input[type="text"]:disabled, 
textarea:disabled { 
    background-color: #f5f5f5; 
    color: #0e0e0e; 
    border-color: #e0e0e0; 
    cursor: not-allowed; 
}

/* Disabled select styling */
.basic-select .select__control--is-disabled {
    background-color: #f5f5f5 !important;
    color: #0e0e0e !important;
    border-color: #e0e0e0 !important;
    cursor: not-allowed !important;
}

.basic-select .react-select__control--is-disabled .select__single-value {
    color: #0e0e0e !important;
}

.basic-select .react-select__control--is-disabled .react-select__placeholder {
    color: #999999 !important;
}
div.select__value-container.select__value-container--has-value > div.select__single-value.select__single-value--is-disabled {
    color: #0e0e0e !important;
}

/* Buttons */
.btn { cursor: pointer; border: 1px solid transparent; border-radius: 10px; padding: 8px 10px; background: #0b5fff; color: #fff; font-weight: 600; font-size: 13px; }
.btn:hover { filter: brightness(0.95); }
.btn-outline { background: #fff; color: #111; border-color: #dce3ee; }
.btn-ghost { background: transparent; border-color: transparent; color: #111; }
.btn-small { padding: 6px 10px; font-weight: 600; font-size: 12px; }
.btn-icon { padding: 6px; width: 30px; height: 30px; display: inline-flex; align-items: center; justify-content: center; }

/* Disabled buttons */
.btn:disabled { 
    background: #f5f5f5; 
    color: #999999; 
    border-color: #e0e0e0; 
    cursor: not-allowed; 
    opacity: 0.6; 
}
.btn:disabled:hover { 
    filter: none; 
}

/* Cards */
.card { background: #ffffff; border: 1px solid #dce3ee; border-radius: 16px; box-shadow: 0 1px 0 rgba(16, 24, 40, .02); padding: 0px 0px 14px 0px; }
.card + .card { margin-top: 10px; }
.card-hd { padding: 10px 12px; display: flex; align-items: center; justify-content: space-between; }
.card-hd-blue { background: #0f2f5f; color: #fff; border-bottom: 1px solid rgba(255,255,255,.08); border-radius: 1rem 1rem 0 0;}
.card-ct { padding: 12px; background: #fff; }
.badge { display: inline-block; padding: 4px 8px; font-size: 12px; border-radius: 999px; background: #e6efff; color: #1f2937; border: 1px solid #dce3ee; }
.badge-title { background: transparent; border: 0; color: #fff; font-weight: 700; letter-spacing: .2px; }
.small { font-size: 12px; color: #6b7280; }

/* Grid */
.grid { display: grid; gap: 12px; }
.grid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
@media (max-width: 920px) { .grid-3 { grid-template-columns: 1fr; } }

/* Operator toggle */
.toggle { display: inline-flex; background: #f1f5f9; border: 1px solid #dce3ee; border-radius: 16px; padding: 3px; }
.toggle button { border: none; background: transparent; padding: 6px 12px; border-radius: 12px; font-weight: 700; font-size: 12px; cursor: pointer; color: #334155; }
.toggle button.active { background: #00b1eb; box-shadow: 0 1px 2px rgba(0,0,0,.06); color: #FFF; }
.toggle.is-header { background: rgba(255,255,255,.18); border-color: rgba(255,255,255,.25); }
.toggle.is-header button { color: #fff; }
.toggle.is-header button.active { background: #fff; color: #0f2450; }

/* Disabled toggle */
.toggle.disabled { background: #f5f5f5; border-color: #e0e0e0; }
.toggle.disabled button { color: #999999; cursor: not-allowed; }
.toggle.disabled button.active { background: #e0e0e0; color: #999999; }

/* Row actions */
.row-actions { display: flex; align-items: center; gap: 6px; }
.summary { color: #111; font-size: 13px; }
.sep { height: 1px; background: #dce3ee; margin: 12px 0; }

.section-title { font-size: 12px; color: #6b7280; margin: 6px 0; }

/* Header overrides for icons */
.card-hd-blue .btn-ghost { color: #fff; }
.card-hd-blue .small { color: rgba(255,255,255,.85); }

`;
